import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ee5684ee"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["onClick", "onMouseenter"]
const _hoisted_2 = { key: 0 }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "insurance-title" }
const _hoisted_5 = { class: "insurance-type" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { class: "insurance-person" }
const _hoisted_9 = {
  key: 0,
  class: "insurance-person"
}
const _hoisted_10 = { class: "mini-btn" }
const _hoisted_11 = { style: {"white-space":"pre-wrap"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_no_data = _resolveComponent("no-data")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data, (item, index) => {
      return (_openBlock(), _createElementBlock("div", {
        class: _normalizeClass({
    programme: true,
    point: true,
    [item.template]: true
    }),
        style: _normalizeStyle({
    'background-image':
    'url(' +
    require('@/assets/img/insurance/bg-' + item.template + '.png') +
    ')'
    }),
        key: index,
        onClick: ($event: any) => (_ctx.$router.push({ path: '/insurance/detail/' + item.policy_id })),
        onMouseenter: ($event: any) => (_ctx.handleMouseMove($event.currentTarget,index)),
        onMouseleave: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleMouseLeave && _ctx.handleMouseLeave(...args)))
      }, [
        (item?.plan?.logo)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("img", {
                class: "insurance-logo",
                src: item.plan.logo,
                onError: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.hideLogo && _ctx.hideLogo(...args)))
              }, null, 40, _hoisted_3)
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_4, _toDisplayString(item?.plan?.name), 1),
          _createElementVNode("div", _hoisted_5, [
            _createTextVNode(_toDisplayString(item?.plan?.type) + " ", 1),
            (item.type == 20 && item.cycle != 'month')
              ? (_openBlock(), _createElementBlock("span", _hoisted_6, " (" + _toDisplayString(_ctx.findKeyByValue(item.cycle)) + ") ", 1))
              : _createCommentVNode("", true),
            (item.type == 20)
              ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(item.end_date) + " 到期 ", 1))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_8, " 当前在保：" + _toDisplayString(item.active_person_count) + "人 ", 1),
          (_ctx.hasAppFeature('closeTime'))
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, " 截单时间：" + _toDisplayString(item.plan.supplier.close_time), 1))
            : _createCommentVNode("", true),
          _createElementVNode("button", _hoisted_10, _toDisplayString(item.mark), 1)
        ])
      ], 46, _hoisted_1))
    }), 128)),
    (_ctx.tipsShow)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "tips",
          style: _normalizeStyle({ top: `${_ctx.y}px`, left: `${_ctx.x}px` })
        }, [
          _createElementVNode("h3", null, _toDisplayString(_ctx.planName), 1),
          _createElementVNode("pre", _hoisted_11, _toDisplayString(_ctx.tips), 1)
        ], 4))
      : _createCommentVNode("", true),
    (_ctx.data.length === 0 && !_ctx.nodata)
      ? (_openBlock(), _createBlock(_component_no_data, { key: 1 }))
      : _createCommentVNode("", true)
  ], 64))
}